export const TASK_TYPE = 'TASK';
export const TASK_DISPLAY_NAME = 'To-do';
